module.exports = __webpack_public_path__ + "img/740w.1d31ffe.jpg";